module.exports = __webpack_public_path__ + "media/images/2-82bfe94f2ceae76c0edec7901be79797.svg";